import { WbTextField } from '@agilelab/plugin-wb-platform';
import { TextFieldProps } from '@material-ui/core/TextField';
import { getInputProps, WidgetProps } from '@rjsf/utils';
import { ChangeEvent, FocusEvent } from 'react';
import { useFormExtraConfigContext } from '../../../contexts/FormExtraConfigContext';
import { extractCustomProperties, isHidden } from '../../utils';

export const TextWidget = ({
  id,
  placeholder,
  required,
  readonly,
  disabled,
  type,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  options,
  schema,
  uiSchema,
  rawErrors = [],
  formContext,
  registry,
  ...textFieldProps
}: WidgetProps) => {
  const inputProps = getInputProps(schema, type, options);
  // Now we need to pull out the step, min, max into an inner `inputProps` for material-ui
  const { step, min, max, ...rest } = inputProps;
  const customProps = uiSchema ? extractCustomProperties(uiSchema) : {};
  const otherProps = {
    inputProps: {
      step,
      min,
      max,
      maxLength: uiSchema?.['ui:options']?.maxLength,
      ...(schema.examples ? { list: `examples_${id}` } : undefined),
    },
    multiline: uiSchema?.['ui:options']?.multiline,
    rows: uiSchema?.['ui:options']?.rows,
    ...rest,
  };
  const _onChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(
      event.target.value === '' ? options.emptyValue : event.target.value,
    );
  const _onBlur = (event: FocusEvent<HTMLInputElement>) =>
    onBlur(id, event.target.value);
  const _onFocus = (event: FocusEvent<HTMLInputElement>) =>
    onFocus(id, event.target.value);

  const { debounceMs } = useFormExtraConfigContext();

  return (
    <WbTextField
      id={id}
      name={id}
      placeholder={placeholder}
      label={schema.title}
      style={{ display: isHidden(uiSchema) ? 'none' : undefined }}
      required={required}
      disabled={disabled || readonly}
      {...otherProps}
      value={value || value === 0 ? value : ''}
      error={rawErrors.length > 0}
      debounceMs={debounceMs}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      {...(textFieldProps as TextFieldProps)}
      {...customProps}
    />
  );
};
